import LTR from "@brand-icons/global/profile-gear/profile-gear-ltr.svg";

import { iconFactory } from "../iconFactory";

export const ProfileGearIcon = iconFactory("ProfileGearIcon", LTR);
